import { Injectable, signal } from '@angular/core'
import { TranslationService } from '../translation/translation.service'
import { TranslateService } from '@ngx-translate/core'
import { Title } from '@angular/platform-browser'

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor(
    private translationService: TranslationService,
    private translateService: TranslateService,
    private titleService: Title,
  ) {}

  formatDateToLocale(dateString: string): string {
    try {
      let date: Date

      // Check if the date string is in DD/MM/YYYY format
      if (dateString.includes('/') && dateString.split('/').length === 3) {
        const parts = dateString.split('/')
        if (
          parts[0].length <= 2 &&
          parts[1].length <= 2 &&
          parts[2].length === 4
        ) {
          // Assume DD/MM/YYYY format and convert to ISO format
          const [day, month, year] = parts
          date = new Date(
            `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`,
          )
        } else {
          date = new Date(dateString)
        }
      } else {
        date = new Date(dateString)
      }

      if (isNaN(date.getTime())) {
        throw new Error('Invalid date')
      }

      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }

      const locale =
        this.translationService.currentLanguage === 'fr' ? 'fr-FR' : 'en-US'

      return new Intl.DateTimeFormat(locale, options).format(date)
    } catch (error) {
      return dateString
    }
  }

  initPageTitle(titleI18nKey: string) {
    this.translateService.get([titleI18nKey]).subscribe((translations) => {
      const translatedTitle = translations[titleI18nKey] ?? ''
      this.titleService.setTitle('E.Leclerc - ' + translatedTitle)
    })
  }

  formatSize(bytes: number | undefined, decimals = 0) {
    if (!bytes || !+bytes) return '0 B'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['B', 'KB', 'MB', 'GB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat(Math.ceil(bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }
}
